export function isCookiePolicyDialogVisibleSelector(state) {
  return (
    Boolean(state.isCookiePolicyDialogVisible) &&
    !state.isLegalDocumentAcceptanceVisible
  );
}
